<template>

    <FloatingPanel>

        <div class="project::canvas-blocks-modules-project-BlockPanel">

            <Tabs :tabs="[
                'Project',
                'Algemeen',
            ]">

                <div slot="Project">

                    <div class="m-5">

                        <div class="mb-1 text-gray-600 label2">Welk project tonen?</div>

                        <small class="block mb-3 text-gray-500 label2 text-muted">Kies hier het project wat
                            getoond dient te gaan worden.</small>

                        <v-select
                            :options="projects"
                            label="labelName"
                            v-model="options.project_id"
                            :reduce="project => project.id">
                            <div slot="no-options">Geen opties</div>
                        </v-select>

                    </div>

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"/>

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

    data() {
        return {
            projects: [],
        };
    },

    created() {
        this.loadProjects();
    },

    methods: {

        async loadProjects() {
            this.projects = (await axios.get(this.adminUrlPrefix + '/projects')).data;
        },

    },

}

</script>

<style lang="scss">

.project\:\:canvas-blocks-modules-project-BlockPanel {
    .v-select {
        .vs__dropdown-menu {
            position: sticky;
        }
    }
}

</style>
